import React from 'react';
import { CompleteKundali, PlanetName, Language } from '../types/kundali';
import { UI_TEXT } from '../utils/language';
import { Triangle } from 'lucide-react';

interface TrinesViewProps {
  kundali: CompleteKundali;
  lang?: Language;
}

export const TrinesView: React.FC<TrinesViewProps> = ({ kundali, lang = 'en' }) => {
  const ui = UI_TEXT[lang as 'en' | 'hi'] || UI_TEXT['en'];
  
  // Trikona Houses: 1, 5, 9 (1-indexed in UI, 0-indexed in array)
  const trineHouses = [0, 4, 8];
  
  return (
    <div className="bg-astro-bg border border-astro-border rounded-2xl p-6 shadow-sm space-y-6">
      <div className="border-b border-astro-border pb-4">
        <h2 className="text-xl font-bold text-astro-text font-serif flex items-center gap-2">
          <Triangle className="w-6 h-6 text-astro-primary" />
          {lang === 'hi' ? 'त्रिकोण (Trikona)' : 'Trines'}
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left text-astro-text text-xs">
          <thead>
            <tr className="border-b border-astro-border text-astro-secondary-text uppercase text-[10px] bg-astro-card">
              <th className="py-2.5 px-4 font-semibold">{lang === 'hi' ? 'घर' : 'House'}</th>
              <th className="py-2.5 px-4 font-semibold">{lang === 'hi' ? 'राशि' : 'Sign'}</th>
              <th className="py-2.5 px-4 font-semibold">{lang === 'hi' ? 'ग्रह' : 'Planets'}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-astro-border">
            {trineHouses.map(houseIdx => {
              const house = kundali.houses[houseIdx];
              const planetsInHouse = kundali.planets.filter(p => p.house === house.houseNumber);
              return (
                <tr key={house.houseNumber} className="hover:bg-astro-card transition-colors">
                  <td className="py-2.5 px-4 font-bold text-astro-primary">House {house.houseNumber}</td>
                  <td className="py-2.5 px-4 font-medium">{house.sign}</td>
                  <td className="py-2.5 px-4 text-astro-secondary-text font-medium">{planetsInHouse.map(p => p.name).join(', ') || 'None'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
